// Cópia dos itens de um registro vinculado (`form-link`) para um campo
// `product-table` do preenchimento atual — ex.: o Carregamento herda os itens do
// Pedido. Configurado no layout do `product-table`:
//
//   "prefill_from": { "link_index": <índice do form-link NESTE layout>,
//                     "source_index": <índice do campo de produtos NO LAYOUT DO ALVO> }
//   "show_prices": true   // opcional — mantém (e exibe) os preços copiados
//
// A cópia é editável e congelada: mudar o Pedido depois não muda o Carregamento.
// Sem `show_prices`, os campos financeiros são REMOVIDOS na cópia — não basta
// esconder na tela, porque o JSON do preenchimento vai para o PDF e para a API.

// Chaves financeiras de um item de `product-order` (ver ProductOrderField).
const PRICE_KEYS = [
  "currency",
  "unit_price",
  "additional_individual",
  "additional_value",
  "final_unit",
  "total_value",
];

// Itens do campo de produtos de origem (`{ group_id, items }`) prontos para o
// destino. Origem ausente ou sem itens: lista vazia.
function copyOrderItems(sourceEntry, { keepPrices = false } = {}) {
  const items = (sourceEntry && Array.isArray(sourceEntry.items) && sourceEntry.items) || [];

  return {
    group_id: (sourceEntry && sourceEntry.group_id) || null,
    items: items.map((item) => {
      const copy = { ...item, extras: Array.isArray(item.extras) ? [...item.extras] : [] };
      if (!keepPrices) PRICE_KEYS.forEach((key) => delete copy[key]);
      return copy;
    }),
  };
}

// Item com a quantidade alterada e os derivados recalculados.
function updateItemQuantity(item, quantity) {
  const qty = Number(quantity) || 0;
  const next = {
    ...item,
    quantity,
    total_quantity: qty * (Number(item.package_quantity) || 0),
  };
  if (item.final_unit !== undefined) {
    next.total_value = (Number(item.final_unit) || 0) * qty;
  }
  return next;
}

// Índices dos `product-table` que copiam do form-link em `linkIndex`.
function fieldsToPrefill(layout, linkIndex) {
  const indexes = [];
  (layout || []).forEach((field, index) => {
    if (
      field &&
      field.type === "product-table" &&
      field.prefill_from &&
      Number(field.prefill_from.link_index) === Number(linkIndex)
    ) {
      indexes.push(index);
    }
  });
  return indexes;
}

// Algum dos campos de destino já tem itens?
function hasPrefilledItems(layout, linkIndex) {
  return fieldsToPrefill(layout, linkIndex).some(
    (index) => (layout[index].items || []).length > 0
  );
}

// Layout com os itens copiados de `values` (o data form vinculado, por índice).
// Por padrão só preenche destino VAZIO — nunca sobrescreve o que o usuário já
// editou (nem os itens mesclados ao reabrir um preenchimento salvo); `replace`
// força a troca. Nada a fazer: devolve o mesmo array.
function applyLinkPrefill(layout, linkIndex, values, { replace = false } = {}) {
  const targets = fieldsToPrefill(layout, linkIndex).filter(
    (index) => replace || (layout[index].items || []).length === 0
  );
  let changed = false;
  const next = layout.map((field, index) => {
    if (!targets.includes(index)) return field;
    const source = (values || [])[field.prefill_from.source_index];
    const copy = copyOrderItems(source, { keepPrices: field.show_prices === true });
    // Origem sem itens não apaga o grupo que o usuário já escolheu no destino.
    if (copy.items.length === 0 && !replace) return field;
    changed = true;
    return { ...field, ...copy };
  });
  return changed ? next : layout;
}

export {
  PRICE_KEYS,
  copyOrderItems,
  updateItemQuantity,
  fieldsToPrefill,
  hasPrefilledItems,
  applyLinkPrefill,
};
